"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AttachmentFile_1 = require("../types/AttachmentFile");
function createLocalComputerFiles(fileList) {
    if (!fileList) {
        return null;
    }
    var localFiles = [];
    for (var i = 0; i < fileList.length; i++) {
        var file = fileList[i];
        var localFile = {
            fileType: AttachmentFile_1.AttachmentFileType.Local,
            name: file.name,
            size: file.size,
            type: file.type,
            fileObject: file,
        };
        localFiles.push(localFile);
    }
    return localFiles;
}
exports.default = createLocalComputerFiles;
//# sourceMappingURL=createLocalComputerFiles.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-attachment-common/lib/utils/createLocalComputerFiles.js
// module id = 4043
// module chunks = 100